import { useEffect, useRef } from 'react'
import { api } from '@convex/_generated/api'
import { useSave } from '@/lib/save'

/**
 * Seeds the timezone from the device on first run.
 *
 * A legitimate effect: it synchronizes with an external system (the server)
 * rather than deriving state. The mutation is idempotent and never overwrites
 * a stored zone, so travelling does not move the day boundary underneath you.
 */
export function SettingsBootstrap() {
  const ensure = useSave(api.settings.ensure)
  const sent = useRef(false)

  useEffect(() => {
    if (sent.current) return
    sent.current = true

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    void ensure({ timeZone }).catch(() => {
      // Non-fatal: the server falls back to UTC and it can be set in Settings.
      sent.current = false
    })
  }, [ensure])

  return null
}
